import { useEffect } from "react";

const SITE_NAME = "美味的快递";

export function usePageMeta(title: string, description?: string, keywords?: string) {
  useEffect(() => {
    document.title = title ? `${title}` : SITE_NAME;

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    if (description) setMeta("description", description);
    if (keywords) setMeta("keywords", keywords);
  }, [title, description, keywords]);
}